<script lang="ts">
	import type { Manufacturer, InventoryType, SearchField } from 'utility/search-fields'
	import type { Type } from './ManufacturerAutocomplete.svelte'
	import type { SvelteSet } from 'svelte/reactivity'

	import ManufacturerAutocomplete from './ManufacturerAutocomplete.svelte'
	import EditModeControls from './EditModeControls.svelte'
	import Pin from './Pin.svelte'
	import type { ComponentProps } from 'svelte'

	interface Props extends ComponentProps<typeof ManufacturerAutocomplete> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		inventoryType?: InventoryType | null | undefined
		manufacturer?: Manufacturer | null
		initialValue?: number // For initial value binding
		type: Type // No default value here, require the consumer to pass the type of manufacturer.
		disabled?: boolean
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		inventoryType = undefined,
		manufacturer = $bindable(null),
		initialValue,
		type,
		disabled = false,
		...rest
	}: Props = $props()
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<ManufacturerAutocomplete
		{...rest}
		bind:manufacturer
		{initialValue}
		{inventoryType}
		{type}
		disabled={disabled || inEditMode}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</ManufacturerAutocomplete>
</EditModeControls>
